import mixitup from 'mixitup';
import mixitupMultifilter from 'mixitup-multifilter';
import SlimSelect from 'slim-select';
mixitup.use(mixitupMultifilter);
export var initWhereToBuyFilters = function initWhereToBuyFilters() {
  var whereToBuy = document.querySelector('.buy-table');

  if (!whereToBuy) {
    return;
  }

  var sectionSelectboxes = document.querySelectorAll(".buy-table__selects select");
  var mixer = mixitup(whereToBuy, {
    multifilter: {
      enable: true,
      logicWithinGroup: 'and',
      logicBetweenGroups: 'and'
    },
    animation: {
      duration: 650,
      nudge: true,
      reverseOut: false,
      effects: 'fade'
    }
  });

  if (sectionSelectboxes.length > 1) {
    sectionSelectboxes.forEach(function (item) {
      new SlimSelect({
        select: item,
        showSearch: false,
        onChange: function onChange(info) {
          mixer.multimix(info.value);
        }
      });
    });
  }
};